import { createReducer, on } from '@ngrx/store';
import { FeedMessage } from '../../model/club-feed';
import { clubFeedActions } from './club-feed.actions';

export interface ClubFeedState {
  messages: Record<number, FeedMessage[]>;
  loading: Record<number, boolean>;
}

const initialState: ClubFeedState = {
  messages: {},
  loading: {},
};

export const clubFeedReducer = createReducer(
  initialState,
  on(
    clubFeedActions.loadClubFeed,
    (state, { clubId }): ClubFeedState => ({
      ...state,
      loading: { ...state.loading, [clubId]: !state.messages[clubId] },
    })
  ),
  on(
    clubFeedActions.reloadClubFeed,
    (state, { clubId }): ClubFeedState => ({
      ...state,
      loading: { ...state.loading, [clubId]: false },
    })
  ),
  on(
    clubFeedActions.loadClubFeedSuccess,
    (state, { clubId, messages }): ClubFeedState => ({
      ...state,
      loading: { ...state.loading, [clubId]: false },
      messages: { ...state.messages, [clubId]: messages },
    })
  ),
  on(
    clubFeedActions.loadClubFeedFailure,
    (state, { clubId }): ClubFeedState => ({
      ...state,
      loading: { ...state.loading, [clubId]: false },
    })
  )
);
